export default __webpack_public_path__ + "static/media/photo--lg--blitz2.cf251283.jpg";